import React, { Component } from "react";

import PropTypes from "prop-types";

import { FormattedDate } from "react-intl";

import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

import classnames from 'classnames';

const myStyle = {
    float: "right"
  };

class InscricaoSmall extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  rowClicked = () => {
    this.context.router.history.push("/backoffice/eventos/" + this.props.evento + "/"+this.props.inscricao._id);
  };

  render() {
    return (
        <TableRow
            onClick={this.rowClicked}
            key={this.props.inscricao._id}
            className={classnames(this.props.inscricao.estaPago === true ? 'esta-pago': 'nao-esta-pago')}
          >
            <TableCell>{this.props.inscricao.name}</TableCell>
            <TableCell>{this.props.inscricao.email}</TableCell>
            <TableCell>{this.props.inscricao.numeroPessoas}</TableCell>
            <TableCell>{
              <FormattedDate
                  value={new Date(this.props.inscricao.enrollmentDate)}
                  year='numeric'
                  month='long'
                  day='2-digit'
                />}
              </TableCell>
                          
            <TableCell>
              <i style={myStyle} className="fas fa-arrow-right" />
            </TableCell>
          </TableRow>
    );
  }
}

export default InscricaoSmall;
